import * as Utils from "./utils";

/**
 * Grabs section from given id
 */
export function getSection(toc, id) {
  for(let section of toc) {
    if(section.id == id) return section;
  }

  return null;
}

/**
 * Grabs childs sections for given parentId
 */
export function getSectionsForParentId(toc, parentId) {
  var childs = [];

  for(let section of toc) {
    if(section.parentId == parentId) {
      childs.push(section);
    }
  }

  return childs;
}

/**
 * Grabs all parent/childs for the given selected section id
 */
export function getParentSectionIds(toc, sectionId) {
  if(!sectionId) return [];

  var section = getSection(toc, sectionId),
      ids = [];

  while(section != null) {
    ids.push(section.id);

    if(section.parentId) {
      section = getSection(toc, section.parentId);
    } else {
      section = null;
    }
  }

  return ids;
}

/**
 * Returns the doc id's that match
 */
export function getMatchingDocumentIdsForSearchResults(documents, searchResults) {
  var documentIds = [],
      allowedDocumentIds = documents.map(function(d) { return d.id; });

  for(let hit of searchResults.hits) {
    if(allowedDocumentIds.indexOf(hit.documentId) != -1 &&
       documentIds.indexOf(hit.documentId) == -1) {
      documentIds.push(hit.documentId);
    }
  }

  return documentIds;
}

/**
 * Returns the matching page numbers from the search result
 */
export function getPageNumbersFromSearchResults(searchResults, documentId) {
  var pageNumbers = [];

  for(let hit of searchResults.hits) {
    if(hit.documentId == documentId) {
      pageNumbers.push(hit.pageNumber);
    }
  }

  return Utils.uniq(pageNumbers.sort());
}

export function getPageNumberFromSectionWithSearchResults(searchResults, section) {
  var pageNumbers = getPageNumbersFromSearchResults(searchResults, section.documentId);

  for(let pageNumber of pageNumbers) {
    if(pageNumber >= section.startPageNumber && pageNumber <= section.endPageNumber) {
      return pageNumber;
    }
  }

  return 1;
}

/**
 * Returns document
 */
export function getDocument(documents, documentId) {
  for(let document of documents) {
    if(document.id == documentId) {
      return document;
    }
  }

  return null;
}

/**
 * Grabs the first section in toc that is a document
 */
export function getFirstSectionWithDocument(toc) {
  for(let section of toc) {
    if(section.level == 1 && section.documentId) return section;
  }
}

/**
 * Grabs page by pageId
 */
export function getPage(document, pageId) {
  for(let page of document.pages) {
    if(page.id == pageId) return page;
  }

  return page;
}

/**
 * Returns the active section from the given toc and pageNumber
 *
 * @NOTE Caution! we add some fake _virtual_ sections to the toc
 */
export function getSectionFromPage(toc, documentId, pageNumber, typeFilter = null) {
  var foundSection = null,
      maxLevel = -1;

  for(let section of toc) {
    if(section.documentId == documentId &&
       section.type == typeFilter &&
       pageNumber >= section.startPageNumber && pageNumber <= section.endPageNumber &&
       section.level > maxLevel) {

      maxLevel = section.level;
      foundSection = section;

    }
  }

  return foundSection;
}

/**
 * Finds the ID in a non-searched toc for the given sectionId from a search-toc
 */
export function getOriginalSectionIdFromSearchToc(toc, sectionId) {
  var foundSectionId;

  // find section from toc
  var section = getSection(
    toc,
    sectionId
  );

  if(section && section.originalId == null) {
    // it has not, so it's a document top level section
    foundSectionId = `document-${section.documentId}`;
  } else if(section) {
    // if it has an originalId, than we can generate the section-id in the toc
    foundSectionId = `section-${section.originalId}`;
  }

  return foundSectionId;
}



// WEBPACK FOOTER //
// ./app/javascript/portal/documents/toc_utils.js